var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2345 5.66278C19.2082 5.08401 19.2082 4.53154 19.2082 3.97907C19.2082 3.53184 18.8662 3.18984 18.4189 3.18984C15.1304 3.18984 12.6312 2.24275 10.5529 0.21704C10.2372 -0.0723468 9.76363 -0.0723468 9.44793 0.21704C7.36961 2.24275 4.87035 3.18984 1.58186 3.18984C1.13463 3.18984 0.792627 3.53184 0.792627 3.97907C0.792627 4.53154 0.792627 5.08401 0.766319 5.66278C0.661087 11.1874 0.50324 18.7641 9.73732 21.9474L10.0004 22L10.2635 21.9474C19.4713 18.7641 19.3397 11.2138 19.2345 5.66278ZM9.36901 13.3184C9.21116 13.4499 9.02701 13.5288 8.81654 13.5288H8.79023C8.57977 13.5288 8.36931 13.4236 8.23777 13.2658L5.79113 10.5561L6.97499 9.50374L8.89547 11.6347L13.1574 7.58326L14.236 8.74081L9.36901 13.3184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimNewIcon);
export default __webpack_public_path__ + "static/media/claimNew_icon.99330fed28e063d421dbe34e8bcce16d.svg";
export { ForwardRef as ReactComponent };